import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { Flex } from '@abyss/web/ui/Flex';
import { Popover } from '@abyss/web/ui/Popover';
import { RadioGroup } from '@abyss/web/ui/RadioGroup';

export const StyledLocationsPopover = styled(Popover, {
  '&.abyss-popover-arrow': {
    display: 'none !important',
  },

  '&.abyss-popover-close-button': {
    margin: '20px 20px 0 0',
  },

  '&.abyss-popover-close-icon': {
    height: '25px',
    width: '25px',
  },

  '&.abyss-popover-content': {
    width: 'auto',
    '@screen < $sm': {
      display: 'none',
    },
  },

  '&.abyss-popover-title': {
    marginTop: '14px',
    marginBottom: '10px',
  },
  '@screen < $sm': {
    width: '100%',
  },
});

export const StyledLocationBoxContainer = styled('div', {
  '.abyss-popover-trigger ~ div': {
    zIndex: '9 !important',
  },
  '@screen < $sm': {
    width: '100%',
  },
});

export const StyledLocationBox = styled(Flex, {
  justifyContent: 'space-between',
  padding: '$md $md',
  minWidth: '407px',
  minHeight: '82px',
  border: '1px solid $neutralGray4',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.09)',
  borderRadius: '4px',
  '@screen < $sm': {
    minWidth: '100%',
  },
  '>div': {
    '@screen < $sm': {
      width: '85%',
    },
  },
});

export const StyledLocationsDropdownOption = styled('div', {
  fontWeight: '700',
  fontSize: '18px',
  lineHeight: '24px',
  color: '#323334',
  textAlign: 'left',
  '@screen < $sm': {
    fontSize: '$md',
    lineHeight: '20px',
  },
});

export const StyledLocationsContentWrapper = styled('div', {
  maxHeight: '180px',
  overflowY: 'auto',
});

export const NonTierOneLocationCSS = {
  display: 'flex',
  alignItems: 'start',
  marginTop: '12px',
  marginLeft: '0',
  padding: '8px 8px 8px 12px',
  maxWidth: '407px',
  minHeight: '56px',
  border: '1px solid #C24E14',
  borderLeft: '4px solid #C24E14',
  borderRadius: '4px',
  backgroundColor: '#FFFBEB',
};

export const NonTierOneLocationContentCSS = {
  width: '363px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  '@screen < $sm': {
    width: 'auto',
  },
};

export const StyledNonTierOneLocationHeader = styled('div', {
  fontWeight: '700',
  fontSize: '16px',
  lineHeight: '20px',
  color: '#323334',
  '@screen < $sm': {
    fontSize: '$md',
  },
});

export const StyledNonTierOneLocationText = styled('div', {
  fontSize: '14px',
  color: '#323334',
  lineHeight: '18px',
  '@screen < $sm': {
    fontSize: '$sm',
  },
});

export const StyledPopoverRadio = styled(RadioGroup.Radio, {
  dynamic: ({ cssProps: { selected } }) => ({
    '&.abyss-radio-label': {
      fontWeight: selected ? '700' : '500',
    },
  }),

  '&.abyss-radio': {
    borderColor: '$interactive1',
  },

  '&.abyss-radio-root': {
    marginLeft: '8px',
    marginRight: '8px',
    marginTop: '10px',
  },

  '&.abyss-radio-label': {
    fontWeight: '500',
    lineHeight: '20px',
    marginBottom: '10px',
    whiteSpace: 'pre-line',
  },
});

export const StyledChangeLocationButton = styled(Button, {
  '&.abyss-button-root': {
    margin: '35.5px 8px 8px 8px',
    '@screen < $sm': {
      margin: '16px 0 0 0',
      width: 'calc(100vw - 32px)',
      height: '42px',
      fontWeight: '600',
    },
  },
});

export const StyledAddressLine = styled('span', {
  display: 'block',
  dynamic: ({ cssProps: { isGehaTheme } }) => ({
    color: isGehaTheme ? '#4C728A' : '',
  }),
});

export const VoiceOnlyText = styled('p', {
  border: '0',
  clip: 'rect(0 0 0 0)',
  height: '1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  userSelect: 'none',
  width: '1px',
});

export const afterHoursPopoverStyle = {
  'abyss-popover-content': {
    color: '#00000026',
    width: 220,
    minHeight: 81,
    maxHeight: 200,
    borderRadius: 4,
    padding: 16,
    overflowY: 'clip' as const,
  },
};
